import { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useCallback, useEffect, useMemo, useState } from "react";
import { Spacings, View } from "react-native-ui-lib";
import { Page } from "@towersystems/roam-common-native";
import { CheckoutRootParamList } from "../../../../types";
import { TextButton } from "@towersystems/roam-common-native";
import { TextField } from "@towersystems/roam-common-native";
import Sale from "../../../../utilities/data/model/Sale";
import { useCheckoutContextProvider } from "../../utils/checkout";
import { useHasTransitionEnded } from "../../../../utilities/use-after-interactions";
import { withSaleController } from "../../utils/sale-controller";
import {
  withObservables,
  ExtractedObservables,
} from "@nozbe/watermelondb/react";
import { of } from "@nozbe/watermelondb/utils/rx";
import { compose } from "recompose";

interface CheckoutEmailReceiptScreenProps
  extends ExtractedObservables<ReturnType<typeof getObserables>>,
    NativeStackScreenProps<
      CheckoutRootParamList,
      "CheckoutEmailReceiptScreen"
    > {
  sale?: Sale;
}

const getObserables = ({ sale }: { sale: Sale }) => ({
  customer: sale ? sale.customer.observe() : of(null),
});

const CheckoutEmailReceiptScreenRenderer = ({
  navigation,
  route,
  customer,
}: CheckoutEmailReceiptScreenProps) => {
  const { sale } = useCheckoutContextProvider();
  const defaultEmailAddress = customer?.emailAddress || "";
  const shouldFocus = useHasTransitionEnded(navigation);

  const [emailAddressInput, setEmailAddressInput] =
    useState(defaultEmailAddress);

  const isValid = useMemo(() => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(emailAddressInput);
  }, [emailAddressInput]);

  const handleOnSend = useCallback(
    async (sale: Sale) => {
      try {
        sale.updateReceiptTo(emailAddressInput);
        navigation.goBack();
      } catch (error) {}
    },
    [emailAddressInput]
  );

  useEffect(() => {
    navigation.setOptions({
      headerRight: () => (
        <View style={{ paddingRight: Spacings.s4 }}>
          <TextButton disabled={!isValid} onPress={() => handleOnSend(sale)}>
            Send
          </TextButton>
        </View>
      ),
    });
  }, [isValid, emailAddressInput]);

  const handleOnChangeText = useCallback(
    (t: string) => {
      setEmailAddressInput(t);
    },
    [setEmailAddressInput]
  );

  return (
    <Page>
      <View>
        <TextField
          placeholder="Email Address"
          validate={["required", "email"]}
          value={emailAddressInput}
          onChangeText={handleOnChangeText}
          autoFocus={shouldFocus}
        />
      </View>
    </Page>
  );
};

export const CheckoutEmailReceiptScreen = compose(
  withSaleController,
  withObservables(["sale"], getObserables)
  // @ts-ignore
)(CheckoutEmailReceiptScreenRenderer);
